<script>
export default {
    name: 'IlluConseilPedagogique',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7',
        },

        secondaryColor: {
            type: String,
            default: '#313132',
        },
    },
}
</script>
<template>
    <svg role="img"
        class="base-illu illu-conseil-pedagogique"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M27.084 28.5c-4.31 0-8.294 1.398-11.522 3.767A19.54 19.54 0 008.525 42a19.54 19.54 0 007.038 9.734A19.412 19.412 0 0027.084 55.5c4.31 0 8.294-1.398 11.522-3.767A19.54 19.54 0 0045.644 42a19.54 19.54 0 00-7.038-9.734A19.412 19.412 0 0027.084 28.5zM54 8.5l-14.13.005A1.496 1.496 0 0038.5 10l.854 13.44 2.94-2.941 11.827.062a1.49 1.49 0 00.973-.47c.25-.269.404-.63.406-1.028l-.005-9.192A1.496 1.496 0 0054 8.5zm-26.916 0c-2.07 0-3.946.84-5.303 2.197A7.477 7.477 0 0019.584 16c0 2.071.84 3.946 2.197 5.303a7.477 7.477 0 005.303 2.197c2.071 0 3.946-.84 5.304-2.197A7.477 7.477 0 0034.584 16c0-2.071-.84-3.946-2.196-5.303A7.477 7.477 0 0027.084 8.5z"
                :stroke="secondaryColor"
                class="secondary-color"
            />
            <rect
                :fill="secondaryColor"
                class="secondary-color"
                x="41"
                y="11"
                width="12"
                height="1"
                rx=".5"
            />
            <rect
                :fill="secondaryColor"
                class="secondary-color"
                x="41"
                y="17"
                width="6"
                height="1"
                rx=".5"
            />
            <rect
                :fill="secondaryColor"
                class="secondary-color"
                x="41"
                y="14"
                width="12"
                height="1"
                rx=".5"
            />
            <path
                d="M27 33c-2.76 0-5 2.223-5 4.965V49h3.612v-4.414h2.777V49H32V37.965C32 35.223 29.762 33 27 33zm-1.388 8.276v-3.31c0-.762.621-1.38 1.388-1.38.767 0 1.39.618 1.39 1.38v3.31h-2.778z"
                :fill="primaryColor"
                class="primary-color"
            />
        </g>
    </svg>
</template>
